import { parseSearchFiltersToUrl } from '~/apps/pu-links/infrastructure/searchUrlHelpers'
import { fetchWithCache } from '../../../utility/fetchWithCache'
import { routeToFilters } from '../../pu-links/infrastructure/routeToFilters'
import { SearchFilters } from '../schemas'
import { PopularLocations } from './schemas'

export async function setupLocations(
  lang: string,
  route: ReturnType<typeof useRoute>,
): Promise<PopularLocations | undefined> {
  const searchFilters = routeToFilters(route)
  const locations = await getLocations({ ...searchFilters, base: null }, lang)
  return locations
}

const EXCLUDED_PARAMS = [
  'av',
  'lat',
  'lng',
  'within',
  'placename',
  'bounds',
  'scroll_to_pitchtype',
  'q',
  'search',
  'type',
  'limit',
  'path',
  'facet',
  'page',
]

async function getLocations(filters: SearchFilters, lang: string) {
  const rawLocations = await fetchLocations(filters.categoryIds || [], lang)
  const urlExtension = getUrlExtension(filters)
  const updatedLocations = {
    ...rawLocations,
    locations: rawLocations.locations.map((location) => ({
      ...location,
      url: `${location.url}${urlExtension}`,
    })),
  }
  return updatedLocations
}

async function fetchLocations(categories: string[], lang: string) {
  const queryParams = new URLSearchParams(categories.map((id) => ['type', id]))
  const url = `/_/fallback/${
    lang === 'en-gb' ? '' : `${lang}/`
  }_/popular-locations/?${queryParams.toString()}`
  const response = await fetchWithCache<PopularLocations>(url)
  return response
}

function getUrlExtension(filters: SearchFilters) {
  const queryParams = new URLSearchParams()
  let urlExtension = ''
  for (const param of parseSearchFiltersToUrl(filters)) {
    if (EXCLUDED_PARAMS.includes(param.filterName)) {
      continue
    }
    queryParams.append(param.filterName, param.filterValue)
  }
  const queryParamsString = queryParams.toString().trim()
  if (queryParamsString) {
    urlExtension = `${urlExtension}?${queryParamsString}`
  }
  return urlExtension
}
